import { connect } from 'react-redux';

import { createBrand } from '@/features/brandCreatePage/actions';

import NewQuestion from './component';

const mapDispatchToProps = { createBrand };

export default connect(null, mapDispatchToProps)(NewQuestion);
